import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgDeliveryOfflineModal',
})
export default class CmgDeliveryOfflineModal extends Vue {
  get visible() {
    return this.$appStore.state.ui.modals.deliveryOfflineModal.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.deliveryOfflineModal.args;
  }

  onClickSwitchToPickup() {
    if (!this.args) {
      return;
    }

    this.args.onSwitchToPickup();
  }

  onClickClose() {
    if (this.args && this.args.onClose) {
      this.args.onClose();
    }

    this.close();
  }

  private close() {
    this.$services.ui.setModalVisibility('deliveryOfflineModal', false);
  }
}
